// SVG mask icon for progress tracking
const ProgressMask = ({ filled = false, index }) => (
  <svg 
    viewBox="0 0 100 60" 
    className={`w-10 h-10 sm:w-12 sm:h-12 transition-all duration-500 ${
      filled 
        ? 'text-[#c5a059] drop-shadow-[0_0_10px_rgba(197,160,89,0.8)]' 
        : 'text-[#c5a059]/20'
    }`}
    style={{ 
      transitionDelay: `${index * 100}ms`,
      transform: filled ? 'scale(1.1)' : 'scale(1)'
    }}
    fill="currentColor"
    data-testid={`progress-mask-${index}`}
  >
    {/* Outer mask shape */}
    <defs>
      <linearGradient id={`maskGradient${index}`} x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#bf953f" />
        <stop offset="25%" stopColor="#fcf6ba" />
        <stop offset="50%" stopColor="#b38728" />
        <stop offset="75%" stopColor="#fbf5b7" />
        <stop offset="100%" stopColor="#aa771c" />
      </linearGradient>
    </defs>
    
    {/* Venetian mask shape */}
    <path 
      d="M50 2C25 2 10 15 3 32C0 40 3 48 10 52C20 58 35 60 50 60C65 60 80 58 90 52C97 48 100 40 97 32C90 15 75 2 50 2Z"
      fill={filled ? `url(#maskGradient${index})` : 'currentColor'}
    />
    
    {/* Eye holes */}
    <ellipse cx="30" cy="32" rx="10" ry="12" fill="#050505" />
    <ellipse cx="70" cy="32" rx="10" ry="12" fill="#050505" />
    
    {/* Decorative elements when filled */}
    {filled && (
      <>
        {/* Crown detail */}
        <path 
          d="M50 8 L45 2 L50 5 L55 2 Z" 
          fill="#fcf6ba" 
          opacity="0.8"
        />
        {/* Side flourishes */}
        <path 
          d="M15 35 Q5 30 8 20" 
          stroke="#fcf6ba" 
          strokeWidth="1.5" 
          fill="none" 
          opacity="0.6"
        />
        <path 
          d="M85 35 Q95 30 92 20" 
          stroke="#fcf6ba" 
          strokeWidth="1.5" 
          fill="none" 
          opacity="0.6"
        />
      </>
    )}
  </svg>
);

export default function MaskProgress({ filled = 0, total = 5 }) {
  return (
    <div 
      className="flex items-center justify-center gap-3 sm:gap-4"
      data-testid="mask-progress"
    >
      {[...Array(total)].map((_, i) => (
        <ProgressMask 
          key={i} 
          filled={i < filled} 
          index={i}
        />
      ))}
    </div>
  );
}
